import request from "@/utils/request";

export default function agentGetChildAgent(params) {
    return request({
        url: `/user/agent/agentGetChildAgent`,
        params
    })
}
